module.exports = __webpack_public_path__ + "static/media/visa.de966a37.svg";